import { render, staticRenderFns } from "./SSDashboardDateRangePicker.vue?vue&type=template&id=2134ecd4&scoped=true&"
import script from "./SSDashboardDateRangePicker.vue?vue&type=script&lang=js&"
export * from "./SSDashboardDateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./SSDashboardDateRangePicker.vue?vue&type=style&index=0&id=2134ecd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134ecd4",
  null
  
)

export default component.exports